import Vue from 'vue'
import Notifications from 'vue-notification'

/*
or for SSR:
import Notifications from 'vue-notification/dist/ssr.js'
*/

Vue.use(Notifications)

const DEFAULT_DURATION = 8000 // 8 seconds

Vue.prototype.$_notify = (payload) => {
  Vue.notify({
    duration: DEFAULT_DURATION,
    ...payload
  })
}
